import React from 'react';

import preferences from 'Preferences';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import Modal, {ModalButton} from 'ui-library/modals/Modal';

import {TENANT_SCHEDULED_MODAL_LAST_DISMISSED_PREFIX, TenantScheduledModal} from './ScheduledModalConstants';

function dismissModal(): void {
  preferences.set(
    `${TENANT_SCHEDULED_MODAL_LAST_DISMISSED_PREFIX}${TenantScheduledModal.GENENTECH_PTD_MODAL_KEY}`,
    new Date().toISOString()
  );
  LegacyModalContainer.close(TenantScheduledModal.GENENTECH_PTD_MODAL_KEY);
}

interface GenentechPTDModalProps {
  buttons: Array<ModalButton>;
  onClose: () => void;
}

function GenentechPTDModalInfo({buttons, onClose}: GenentechPTDModalProps): JSX.Element {
  return (
    <Modal
      enableRedesign={true}
      title="Legal Disclaimer"
      buttons={buttons}
      onRequestClose={onClose}
      closeable={false}
      closeableOnBackgroundClick={false}
      closeableOnEscapeKey={false}
    >
      <div>
        <p>
          I acknowledge that I am bound by confidentiality obligations imposed through my employment or
          contractual agreement with Roche in connection with my access to confidential information, including
          PTD Benchling and its contents. By entering PTD Benchling, I confirm that I understand that my
          activities within PTD Benchling may be monitored consistent with local law, and all contents and
          passwords are confidential information, and that unauthorized disclosure or use of such confidential
          information may result in disciplinary action including termination of my employment or services
          and/or legal action based on local law.
        </p>
      </div>
    </Modal>
  );
}

export function GenentechPTDModal(): JSX.Element {
  return (
    <GenentechPTDModalInfo
      onClose={() => {
        dismissModal();
      }}
      buttons={[
        {
          text: 'I Agree',
          style: 'default',
          onClick: () => {
            dismissModal();
          },
        },
      ]}
    />
  );
}
